module.exports = __webpack_public_path__ + "img/portada4.80f2fd4f.jpeg";